import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { db } from '../firebase'; 
import { ref, push, onValue, limitToLast, query } from "firebase/database";

const Chat = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [userName, setUserName] = useState("");
  const [isNameSet, setIsNameSet] = useState(false);
  const [tempName, setTempName] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [messages, setMessages] = useState([]);
  const scrollRef = useRef(null);

  useEffect(() => {
    const savedName = localStorage.getItem("chat_username");
    if (savedName) {
      setUserName(savedName);
      setIsNameSet(true);
    }
  }, []);

  useEffect(() => {
    const messagesRef = query(ref(db, 'messages'), limitToLast(50));
    const unsubscribe = onValue(messagesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const loadedMessages = Object.keys(data).map(key => ({
          id: key,
          ...data[key]
        }));
        setMessages(loadedMessages);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, isOpen]);

  const getSpecialTag = (name) => {
    const n = name.toLowerCase().trim();
    if (n === 'etmin' || n === 'vixion') return { label: '🫔', color: '#ffee00a6' };
    if (n === 'moderator') return { label: 'MOD', color: '#2ed573' };
    return null;
  };

  const handleSetName = (e) => {
    if (e) e.preventDefault();
    if (tempName.trim() !== "") {
      setUserName(tempName);
      setIsNameSet(true);
      localStorage.setItem("chat_username", tempName);
    }
  };

  const handleSendMessage = (e) => {
    if (e) e.preventDefault();
    if (inputValue.trim() !== "" && isNameSet) {
      const tag = getSpecialTag(userName);
      
      push(ref(db, 'messages'), {
        sender: userName,
        text: inputValue,
        timestamp: Date.now(),
        tag: tag || null
      });

      setInputValue("");
    }
  };

  return (
    // PERBAIKAN DI SINI: Menambahkan display flex, column, dan align-items flex-end
    <div style={{ 
      position: 'fixed', 
      bottom: '20px', 
      right: '20px', 
      zIndex: 99999, 
      fontFamily: 'sans-serif',
      display: 'flex',          // Baru
      flexDirection: 'column',  // Baru
      alignItems: 'flex-end'    // Baru: Memastikan tombol tetap di kanan saat chat terbuka
    }}>
      <AnimatePresence>
        {isOpen && (
          <motion.div 
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 20 }}
            style={{ width: '320px', background: '#11121a', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 20px 40px rgba(0,0,0,0.4)', display: 'flex', flexDirection: 'column', marginBottom: '15px', position: 'relative' }}
          >
            {/* Header */}
            <div style={{ padding: '18px', background: '#1a1c26', color: '#fff', fontWeight: 'bold', borderBottom: '1px solid #333' }}>
              Live Chat
            </div>

            {/* Modal Nama */}
            {!isNameSet && (
              <div style={{ position: 'absolute', inset: 0, background: '#11121a', zIndex: 20, display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '20px' }}>
                <h4 style={{ color: '#fff', textAlign: 'center' }}>Input Username</h4>
                <input 
                  type="text" value={tempName} onChange={(e) => setTempName(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSetName()}
                  style={{ padding: '10px', borderRadius: '8px', border: 'none', background: '#24283b', color: '#fff', marginTop: '10px' }}
                />
                <button onClick={handleSetName} style={{ marginTop: '10px', padding: '10px', background: '#7aa2f7', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer' }}>Submit</button>
              </div>
            )}

            {/* Chat Body */}
            <div ref={scrollRef} style={{ height: '300px', padding: '15px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '10px' }} className="hide-scrollbar">
              {messages.map((msg) => (
                <div key={msg.id} style={{ alignSelf: msg.sender === userName ? 'flex-end' : 'flex-start', maxWidth: '80%' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '2px' }}>
                    <small style={{ color: '#7aa2f7', fontSize: '10px' }}>{msg.sender}</small>
                    {msg.tag && <span style={{ background: msg.tag.color, color: '#000', fontSize: '8px', padding: '1px 4px', borderRadius: '3px', fontWeight: 'bold' }}>{msg.tag.label}</span>}
                  </div>
                  <div style={{ background: msg.sender === userName ? '#7aa2f7' : '#24283b', color: '#fff', padding: '8px 12px', borderRadius: '12px', fontSize: '14px' }}>
                    {msg.text}
                  </div>
                </div>
              ))}
            </div>

            {/* Input */}
            <form onSubmit={handleSendMessage} style={{ padding: '15px', background: '#1a1c26', display: 'flex', gap: '10px' }}>
              <input 
                type="text" value={inputValue} onChange={(e) => setInputValue(e.target.value)}
                placeholder="Message..." style={{ flex: 1, background: '#24283b', border: 'none', color: '#fff', padding: '8px', borderRadius: '8px', outline: 'none' }}
              />
              <button type="submit" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#7aa2f7"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
              </button>
            </form>
          </motion.div>
        )}
      </AnimatePresence>

      <button onClick={() => setIsOpen(!isOpen)} style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#7aa2f7', border: 'none', cursor: 'pointer', boxShadow: '0 5px 15px rgba(0,0,0,0.3)' }}>
        <svg width="30" height="30" viewBox="0 0 24 24" fill="white"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/></svg>
      </button>
    </div>
  );
};

export default Chat;